import { render, staticRenderFns } from "./PollMultipleResultsPie.vue?vue&type=template&id=7546112e&scoped=true"
import script from "./PollMultipleResultsPie.vue?vue&type=script&lang=js"
export * from "./PollMultipleResultsPie.vue?vue&type=script&lang=js"
import style0 from "./PollMultipleResultsPie.vue?vue&type=style&index=0&id=7546112e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7546112e",
  null
  
)

export default component.exports